import { http } from '@/plugins/axios';

const getMobileAppSettings = (): Promise<any> => {
  return http.get('/Config/MobileAppSettings');
};

export default {
  getMobileAppSettings,
};
